import { Link } from 'react-router-dom';
import { useInstallPrompt } from './useInstallPrompt';

/**
 * Dismissible install nudge shown in the chrome while running in a plain browser tab.
 * Dismissal persists per device; Settings → "Show install banner again" brings it back,
 * and the /install page plus its Settings link always work regardless.
 */
export function InstallBanner(): JSX.Element | null {
  const { installed, bannerDismissed, dismissBanner } = useInstallPrompt();

  if (installed || bannerDismissed) return null;

  return (
    <div data-testid="install-banner" className="border-b border-line bg-surface">
      <div className="mx-auto flex max-w-5xl items-center justify-between gap-3 px-4 py-2 text-sm">
        <p className="min-w-0 text-fg-2">
          <Link to="/install" className="font-semibold text-accent underline">
            Install AwwYeah
          </Link>{' '}
          for full-screen, offline, and notifications.
        </p>
        <button
          type="button"
          onClick={dismissBanner}
          aria-label="Dismiss install suggestion"
          data-testid="install-banner-dismiss"
          className="min-h-[44px] min-w-[44px] shrink-0 rounded-xl px-2 font-semibold text-fg-3"
        >
          Not now
        </button>
      </div>
    </div>
  );
}
